/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WGGameAssets} from "./WGGameAssets";
import {WGSoundConfig} from "./WGSoundConfig";
import {FontConfig} from "./FontConfig";
import {WGGameConfig} from "./WGGameConfig";
import {GameController} from "@nolimitcity/slot-game/bin/core/gamecontroller/GameController";
import {ReelStartPresentation} from "./presentations/reel/ReelStartPresentation";
import {ReelStopPresentation} from "./presentations/reel/ReelStopPresentation";
import {ReelStoppedPresentation} from "./presentations/reel/ReelStoppedPresentation";
import {WGEngineManager} from "./engine/WGEngineManager";
import {WGParsedInitData} from "./server/data/WGParsedInitData";
import {WGParsedGameData} from "./server/data/WGParsedGameData";
import {WGServerDataParser} from "./server/WGServerDataParser";
import {IBlankGameData, IBlankInitData} from "./server/data/IBlankServerData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {WGZeroBetController} from "./zerobet/WGZeroBetController";
import {WGInitialWinPresentation} from "./presentations/features/win/initialwin/WGInitialWinPresentation";
import {BigWinPrsentation} from "./presentations/features/bigwin/BigWinPrsentation";
import {WarriorPayFeature} from "./presentations/features/warriorpayfeature/WarriorPayFeature";
import {WildNudgePresentation} from "./presentations/features/nudge/WildNudgePresentation";
import {IntroPresentation} from "./presentations/features/intro/IntroPresentation";
import {OutroPresentation} from "./presentations/outro/OutroPresentation";
import {BetlinesAndWinbox} from "./presentations/features/BetlinesAndWinbox";
import {WGLastPresentation} from "./presentations/features/individual/WGLastPresentation";
import {WGNoWinPresentation} from "./presentations/WGNoWinPresentation";
import {WGStickyMultiplier} from "./presentations/WGStickyMultiplier";
import {WGAnticipation} from "./presentations/WGAnticipation";
import {ResizeHelper} from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import {RestorePresentation} from "./presentations/features/restore/RestorePresentation";
import {WGUpdateFreeSpinLeftMeter} from "./presentations/reel/WGUpdateFreeSpinLeftMeter";
import {FreeSpinTriggerPresentation} from "./presentations/features/freespin/FreeSpinTriggerPresentation";
import {WGStackAnimationController} from "./presentations/stackAnimation/WGStackAnimationController";
import {WarriorFeatureWinPresentation} from "./presentations/features/warriorpayfeature/WarriorFeatureWinPresentation";
import {StickyWild} from "./presentations/features/stickyWild/StickyWild";
import {StickyWildView} from "./presentations/features/stickyWild/StickyWildView";
import {WGStillImageBackground} from "./background/WGStillImageBackground";
import {SoundManager} from "./resource/sound/SoundManager";
import {FeaturePrice} from "./server/data/FeaturePrice";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {IndiSymWinHighlightPresentation} from "./presentations/IndiSymWinHighlightPresentation";

export class WarriorGraveyardGameModuleConfig implements IGameModuleConfig {

    public static instance: WarriorGraveyardGameModuleConfig = new WarriorGraveyardGameModuleConfig();
    private static EngineManager: WGEngineManager;
    public static background: WGStillImageBackground;
    public static stickWildView: StickyWildView;
    public static featurePrice: FeaturePrice;

    public static reelArea: StillImageBackground;
    public static stackAnimationPlayer: WGStackAnimationController;
    public static betlineWinBox: BetlinesAndWinbox
    public static stickMuliplier: WGStickyMultiplier;
    public static freeSpinLeftMeter: WGUpdateFreeSpinLeftMeter;
    public static anticipationAnimation: WGAnticipation;
    private static resizeHelper: ResizeHelper = new ResizeHelper();

    GAME_CONFIG: IGameConfig = WGGameConfig.instance;
    SOUND_CONFIG: ISoundConfig = WGSoundConfig.instance;
    FONTS_CONFIG: IFontsConfig = FontConfig.FONTS;
    RESOURCES_CONFIG: IResourcesGroupConfig = WGGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER: () => WGServerDataParser = () => new WGServerDataParser();

    PARSED_INIT_DATA: (data: any, dataParser: ServerDataParser) => ParsedInitData = (data: IBlankInitData, dataParser: ServerDataParser) => new WGParsedInitData(data, <WGServerDataParser>dataParser);
    PARSED_GAME_DATA: (data: any, dataParser: ServerDataParser) => ParsedGameData = (data: IBlankGameData, dataParser: ServerDataParser) => new WGParsedGameData(data, <WGServerDataParser>dataParser);

    GAME_CONTROLLER: () => GameController = () => {
        return new GameController({
            PRESENTATIONS: [
                {
                    /* The first PresentationList that triggers when restore has been defined. */
                    eventType: SpinEvent.RESTORE,
                    presentations: [new RestorePresentation({
                        name: "RestorePresentation",
                        layer: WGGameConfig.instance.LAYERS.INTRO.name
                    })]
                },
                {
                    /* Not functional, conflicts with the current Replay function. */
                    eventType: SpinEvent.INTRO,
                    presentations: []
                },
                {
                    eventType: SpinEvent.IDLE,
                    presentations: [new WGLastPresentation({
                        name: "WGLastPresentation",
                        layer: WGGameConfig.instance.LAYERS.WIN_FRAMES.name
                    })]
                },
                {
                    /* Prefer to use only one ReelStartPresentation. */
                    eventType: SpinEvent.START,
                    presentations: [new ReelStartPresentation()]
                },
                {
                    /* This is the only PresentationList that will be triggered multiple times from different events.
                    * 1: When START is done.
                    * 2: When Data has been parsed.
                    * 3: When QuickStop Has been Triggered.
                    * 4: Retriggers the STOP is done. (This is an Old behaviour, this could be removed if we use this system in the future.)
                    */
                    eventType: SpinEvent.STOP,
                    presentations: [new ReelStopPresentation()]
                },
                {
                    /*x
                    * A normal TriggerList
                    */
                    eventType: WinPresentationEvent.WIN_PRESENTATIONS_STARTED,
                    presentations: [
                        new ReelStoppedPresentation(),

                        new WildNudgePresentation(
                            {
                                name: "WildNudgePresentation",
                                layer: WGGameConfig.instance.LAYERS.SYMBOL_OVERLAY.name
                            }),
                        new StickyWild(),
                        new IndiSymWinHighlightPresentation({
                            name:"indiSymWinHighlightPresentation",
                            layer: WGGameConfig.instance.LAYERS.INDI_SYM_WIN.name
                        }),
                        new WGNoWinPresentation(),
                        new WGInitialWinPresentation(),
                        new WarriorPayFeature(),
                        new WarriorFeatureWinPresentation(),

                        new BigWinPrsentation(
                            {
                                name: "BigWinPrsentation",
                                layer: WGGameConfig.instance.LAYERS.BIG_WIN.name
                            }
                        ),
                        new FreeSpinTriggerPresentation(),

                        new IntroPresentation({
                            name: "FreespinIntro",
                            layer: WGGameConfig.instance.LAYERS.INTRO.name
                        }),

                        new OutroPresentation({
                            name: "FreeSpinOutro",
                            layer: WGGameConfig.instance.LAYERS.INTRO.name
                        })
                    ]
                }
            ]
        });
    }

    GAME_FEATURE_CREATOR: () => void = () => {
        WarriorGraveyardGameModuleConfig.freeSpinLeftMeter = new WGUpdateFreeSpinLeftMeter();
        WarriorGraveyardGameModuleConfig.stickWildView = new StickyWildView();
        WarriorGraveyardGameModuleConfig.stackAnimationPlayer = new WGStackAnimationController();
        new SoundManager();
        WarriorGraveyardGameModuleConfig.stickMuliplier = new WGStickyMultiplier();
        WarriorGraveyardGameModuleConfig.anticipationAnimation = new WGAnticipation();
        WarriorGraveyardGameModuleConfig.betlineWinBox = new BetlinesAndWinbox();
        WarriorGraveyardGameModuleConfig.featurePrice = new FeaturePrice();

        WarriorGraveyardGameModuleConfig.EngineManager = new WGEngineManager(WGGameConfig.instance.REEL_ENGINE_CONFIG);
        WarriorGraveyardGameModuleConfig.background = new WGStillImageBackground({
            layer: WGGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages: {
                NORMAL: {image: WGGameAssets.MAIN_GAME_BACKGROUND, offset: new PIXI.Point(-480, -480)},
                FREESPIN: {image: WGGameAssets.FS_BACKGROUND, offset: new PIXI.Point(-480, -480)}
            },
            stretch: false
        });

        WarriorGraveyardGameModuleConfig.reelArea = new StillImageBackground({
            layer: WGGameConfig.instance.LAYERS.REEL_BACKGROUND.name,
            backgroundImages: {
                NORMAL: {
                    image: WGGameAssets.REEL_BACKGROUND,
                    offset: new PIXI.Point(-415, -178),
                },
                FREESPIN: {
                    image: WGGameAssets.REEL_BACKGROUND_FS,
                    offset: new PIXI.Point(-415, -178),
                }
            },
            stretch: false
        });
    };

    ZERO_BETS: (() => ZeroBetController)[] = [
        () => new WGZeroBetController()
    ];

    INDIVIDUAL_WIN_PRESENTATION: () => IndividualWinPresentationController;

    constructor() {
        if (WarriorGraveyardGameModuleConfig.instance) {
            throw new Error("WarriorGraveyardGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}